import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import Button from 'common/components/elements/buttons/primary';
import Icon from 'common/components/elements/icons';
import { getAllowedVideoExtentions, moreInfoProps } from 'common/utils/utils';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_STORIES } from 'common/utils/intercom-articles';

class AddNewStory extends Component {
   static propTypes = {
      onCloseAddNewStory: PropTypes.func.isRequired,
      onImagesChange: PropTypes.func,
      onVideoChange: PropTypes.func,
      isUploading: PropTypes.bool,
      isDemoMode: PropTypes.bool,
   };

   hideAddnewStorylayer(e) {
      const { onCloseAddNewStory } = this.props;
      if(e.target === this.addnewStoryElem) {
         onCloseAddNewStory();
      }
   }

   addPhotoStory() {
      if(this.uploadStoryImageRef) {
         this.uploadStoryImageRef.click();
      }
   }

   addVideoStory() {
      const { onVideoChange } = this.props
      if(this.uploadStoryVideoRef) {
         this.uploadStoryVideoRef.click();
      } else onVideoChange()
   }

   uploadImage(e) {
      const { onImagesChange } =  this.props
      const file = e.target.files
      onImagesChange(file)
   }

   uploadVideo(e) {
      const { onVideoChange } = this.props
      onVideoChange(e)
   }

   render() {
      const { isUploading, onCloseAddNewStory, isDemoMode } = this.props;
      const allowedExtentions = getAllowedVideoExtentions();
      const accept = ['.mov', ...allowedExtentions].join(',')
      return (
         <div
            className='adminDashboard__addnewStory w-full flex items-end'
            ref={ (ref) => this.addnewStoryElem = ref }
            onClick={ (e) => this.hideAddnewStorylayer(e) }
            role='presentation'
         >
            <div className='w-full flex flex-col bg-panel'>

               <div className='header-shadow px-5 py-3 flex items-center z-2'>
                  <div className='close-button w-6 h-6 mr-5'>
                     <Button
                        iconName='close'
                        fontIconColor='major'
                        classNames='h-full w-full'
                        backgroundColor='transparent'
                        padding='none'
                        onClick={ () => onCloseAddNewStory(false) }
                     />
                  </div>
               </div>
               <div className='w-full rounded-t-lg p-4 pb-2'>
                  <div className='flex gap-4'>
                     <div
                        className={ `py-12 bg-grey-main rounded-lg flex-1 flex flex-col items-center select-none ${ isDemoMode ? 'cursor-default text-disabled' : 'cursor-pointer text-major hover:bg-grey-hover' }` }
                        onClick={ () => !isDemoMode && this.addPhotoStory() }
                        role='presentation'
                        data-tooltip-content={ isDemoMode ? 'Not available in demo' : '' }
                        data-tooltip-id='ams-top-tooltip'
                     >
                        <Icon name='add-photos' size='2xl' color='secondary' disabled={ isDemoMode } />
                        <p className='mt-2 font-medium '>Add a photo</p>
                     </div>
                     <div
                        className={ `py-12 bg-grey-main rounded-lg flex-1 flex flex-col items-center select-none ${ isDemoMode ? 'cursor-default text-disabled' : 'cursor-pointer text-major hover:bg-grey-hover' }` }
                        onClick={ () => !isDemoMode && this.addVideoStory() }
                        role='presentation'
                        data-tooltip-content={ isDemoMode ? 'Not available in demo' : '' }
                        data-tooltip-id='ams-top-tooltip'
                     >
                        <Icon name='video-camera' size='2xl' color='secondary' disabled={ isDemoMode } />
                        <p className='mt-2 font-medium'>Add a video</p>
                     </div>
                  </div>
                  <div className='more-info-button items-center w-full mt-2'>
                     <Button
                        text='More info on stories'
                        textColor='action'
                        backgroundColor='transparent'
                        textSize='base'
                        iconName='attention-outline'
                        iconPosition='left'
                        fontIconColor='action'
                        fontIconSize='base'
                        primaryColor
                        { ...moreInfoProps() }
                        onClick={ () => Intercom.showArticle(ARTICLE_ID_ON_STORIES) }
                        // classNames='intercom-more-info-on-stories'
                     />
                  </div>

                  {
                     !isUploading && (
                        <input
                           type='file'
                           ref={ (ref) => this.uploadStoryVideoRef = ref }
                           hidden
                           multiple={ false }
                           accept={ `${ accept }` }
                           name='video'
                           onChange={ e => this.uploadVideo(e) }
                           disabled={ isDemoMode }
                        />
                     )
                  }
                  <input
                     type='file'
                     ref={ (ref) => this.uploadStoryImageRef = ref }
                     hidden
                     multiple
                     accept='image/png,image/jpeg, image/webp'
                     name='image'
                     onChange={ e => this.uploadImage(e) }
                     disabled={ isDemoMode }
                  />
               </div>
            </div>
         </div>
      );
   }
}

export default AddNewStory;
